import { environmentHttpClient } from "client/Api/httpClient";
import { RenderImageType } from "./common";

export type AppIconRestrictions = {
	maxFileSize: number;
	svgMaxFileSize: number;
	supportedImageTypes: string[];
};

export function getRestrictions(signal?: AbortSignal): Promise<AppIconRestrictions> {
	return environmentHttpClient.get<AppIconRestrictions>(
		"AppIcon/GetRestrictions",
		null,
		{ signal }
	);
}

export type SaveAppIconModel = {
	name: string;
	image: OptionalModel<Base64FileUriUploadModel>;
};

export function createTileIcon(
	model: SaveAppIconModel,
	signal?: AbortSignal
): Promise<AvailableIcon> {
	return environmentHttpClient.post<AvailableIcon>(
		"/AppIcon/CreateTileIcon/",
		model,
		{ signal }
	);
}

export function updateTileIcon(
	id: number,
	model: SaveAppIconModel,
	signal?: AbortSignal
): Promise<AvailableIcon> {
	return environmentHttpClient.put<AvailableIcon>(
		`/AppIcon/UpdateTileIcon/${id}`,
		model,
		{ signal }
	);
}

export enum AppIconCategoryKind {
	Adobe = 1,
	Microsoft = 2,
	Brands = 3,
	Devices = 4,
	Finance = 5,
	Social = 6,
	Healthcare = 7,
	Education = 8,
	Transport = 9,
	Google = 10,
	Weather = 11,
	BusinessApps = 12,
	Documents = 13,
	CRM = 14,
	Development = 15,
	Browsers = 16,
	Time = 17,
	Sounds = 18,
	Other = 19,
	Custom = 20
};

export type AvailableIcon = {
	id: number;
	name: string;
	url: string;
	type: AppImageType;
	renderType: RenderImageType;
	categoryKind: AppIconCategoryKind;
};

export type AvailableIconsModel = {
	canUploadAndManage: boolean;
	icons: readonly AvailableIcon[];
};

export function getAvailableIcons(signal?: AbortSignal): Promise<AvailableIconsModel> {
	return environmentHttpClient.get<AvailableIconsModel>(
		"AppIcon/GetAvailableIcons",
		null,
		{ signal }
	);
}

export function deleteTileIcon(id: number, signal?: AbortSignal): Promise<void> {
	return environmentHttpClient.post<void>(
		`/AppIcon/DeleteTileIcon/${id}`,
		null,
		{ signal }
	);
}

export enum AppImageType {
	Global = 0,
	Environment = 1
}
